import { GuidedTour } from "@components/common/GuidedTour";
import { usePreferences } from "@hooks";
import { useTour } from "@hooks/use-tour";

const steps = [
  {
    // Step 0: On /inbox — Ready to Export tab
    skipBeacon: true,
    target: '[data-testid^="export-note-item-"]',
    placement: "bottom",
    title: "Ready to Export",
    content:
      'These notes have been reviewed and are ready to export to your PIMS. Click "Open Note" to get started!',
    blockTargetInteraction: false,
    buttons: [],
  },
  {
    // Step 1: On the note page — scroll to export section
    skipBeacon: true,
    target: '[data-testid="export-note-header"]',
    placement: "bottom",
    title: "Export Your Note",
    content:
      "This is where you can export your note to your PIMS. Choose from Widget Mode, PIMSPal, copy, PDF, or email — whatever works best for your workflow!",
  },
];

export default function ExportNoteTour() {
  const { exportNoteTourSeen, setExportNoteTourSeen } =
    usePreferences();

  const { run, stepIndex, handleCallback } = useTour({
    name: "Export Note to PIMS",
    steps,
    isActive: !exportNoteTourSeen,
    onComplete: () => setExportNoteTourSeen(true),
    pollForStart: true,
  });

  return (
    <GuidedTour
      steps={steps}
      run={run}
      stepIndex={stepIndex}
      onEvent={handleCallback}
      skipScroll={stepIndex === 0}
      locale={{ last: "Got it!" }}
    />
  );
}
